import React, { useState, useEffect } from "react";
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/GetApp';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Stack, Skeleton, Card, Container, IconButton, Modal, Tab, Tabs, Box } from "@mui/material";


import Datastore from "../../../store/hoa-datastore";
import { urlCheck } from "../../../utility/url-check";
import { getDateOnly } from "../../../utility/get-formated-date";
import { GenerateNewDocumentUrl } from "../../../utility/generate-new-document-url";
import { getNegativeValueInAccountingForm } from "../../../utility/format-display-output";
import HoaPropertyViolationStagesModal from "../property-forms/hoa-property-violation-stages-list";

const PropertyViolation = ({ violationDetails, violationList, isViolationLoading, setViolationLists, hoaDueList, setHoaDueLists, isHoaDueLoading }: any) => {
    const [parentViolationList ,setParentViolationList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState(0);

    const onFileDOwnloadClick = (url :string) => {
        window.open(urlCheck(url), '_blank');
    }

    const details: any = {
        'Violation Fees Outstanding': getNegativeValueInAccountingForm(violationDetails.hoaPropertyDetails['violationFeeOutstanding']),
        'Total Violation': violationDetails.hoaPropertyDetails['totalViolation'] || '0',
        'No. of Violation/Year': violationDetails.hoaPropertyDetails['numberOfViolation'] || '0',
        'Avg. Violation/Year': violationDetails.hoaPropertyDetails['avgViolation'] || '0',
        'Invoices Outstanding': getNegativeValueInAccountingForm(violationDetails.hoaPropertyDetails['invoicesOutstanding']),
        'Total Invoices': violationDetails.hoaPropertyDetails['totalInvoices'] || '0',
        'Assessment Fee': violationDetails.hoaPropertyDetails['assesmentFee'] || '0',
        'Assessment Fee Frequency': violationDetails.hoaPropertyDetails['assesmentFeeFrequency'] || 'N/A',
        'Assessment Fee Sub HOA': violationDetails.hoaPropertyDetails['assessmentFeeSubHoa'] || '0',
        'Assessment Fee Frequency Sub HOA': violationDetails.hoaPropertyDetails['assessmentFeeFrequencySubHoa'] || 'N/A',
    }

    useEffect(() => {
		if (Array.isArray(violationList) && violationList.length > 0) {
			let parentViolations:any = [];
			let childViolationIds:any = [];

			violationList.forEach((item:any) => {
				if (Array.isArray(item.childViolationIdsList)) {
					item.childViolationIdsList.forEach((id:string) => {
						if (!childViolationIds.includes(id)) {
							childViolationIds.push(id);
						}
					})
				}
			});

			parentViolations = JSON.parse(JSON.stringify(violationList)).filter((item:any) => {
				return !childViolationIds.includes(item.objectId);
			});

			setParentViolationList(parentViolations);
		}
	}, [violationList]);

    const activeViolationList = parentViolationList.filter((value: any) => value.noticeStatus !== "resolved") || [];
    const resolveViolationList = parentViolationList.filter((value: any) => value.noticeStatus !== 'active')|| [];

    const activeHoaDueList = hoaDueList.filter((value: any) => value.noticeStatus !== "resolved") || [];
    const resolveHoaDueList = hoaDueList.filter((value: any) => value.noticeStatus !== 'active')|| [];

    return (
        <Stack direction={{ xs: "column", sm: "column", md: "row" }}>
            <Stack
                flex={1}
                padding={"24px"}
                flexWrap={"wrap"}
                direction={"column"}
                borderRight={"1px solid #E8E8E8"}
            >
                <span className="overview-title-text">Basic Information</span>
                <Stack
                    style={{ borderBottom: "1px solid #E8E8E8", paddingBottom: "24px" }}
                    direction={"row"}
                    flexWrap={"wrap"}
                >
                    {["Violation Fees Outstanding", "Total Violation", "No. of Violation/Year", "Avg. Violation/Year", "Invoices Outstanding", "Total Invoices"].map(
                        (title: string, index: number) => {
                            return (
                                <Stack
                                    key={index}
                                    style={{ marginRight: "40px", marginTop: "24px" }}
                                    direction="column"
                                    width={'200px'}
                                >
                                    <span className="text-787878-14px bold">{title}</span>
                                    <span
                                        style={{ marginTop: "10px" }}
                                        className="text-303030-16px normal"
                                    >
                                        {details[title]}
                                    </span>
                                </Stack>
                            );
                        }
                    )}
                </Stack>
                <span className="overview-title-text" style={{paddingTop: "24px"}}>Master HOA</span>
                <Stack
                    style={{ paddingBottom: "24px" }}
                    direction={"row"}
                    flexWrap={"wrap"}
                >
                    {["Assessment Fee", "Assessment Fee Frequency"].map(
                        (title: string, index: number) => {
                            return (
                                <Stack
                                    key={index}
                                    style={{ marginRight: "40px", marginTop: "24px" }}
                                    direction="column"
                                    width={'200px'}
                                >
                                    <span className="text-787878-14px bold">{title}</span>
                                    <span
                                        style={{ marginTop: "10px" }}
                                        className="text-303030-16px normal"
                                    >
                                        {details[title]}
                                    </span>
                                </Stack>
                            );
                        }
                    )}
                </Stack>
                <span className="overview-title-text">Sub HOA</span>
                <Stack
                    style={{ paddingBottom: "24px" }}
                    direction={"row"}
                    flexWrap={"wrap"}
                >
                    {["Assessment Fee Sub HOA", "Assessment Fee Frequency Sub HOA"].map(
                        (title: string, index: number) => {
                            return (
                                <Stack
                                    key={index}
                                    style={{ marginRight: "40px", marginTop: "24px" }}
                                    direction="column"
                                    width={'200px'}
                                >
                                    <span className="text-787878-14px bold">{title === 'Assessment Fee Sub HOA' ? 'Assessment Fee' : 'Assessment Fee Frequency'}</span>
                                    <span
                                        style={{ marginTop: "10px" }}
                                        className="text-303030-16px normal"
                                    >
                                        {details[title]}
                                    </span>
                                </Stack>
                            );
                        }
                    )}
                </Stack>
            </Stack>
            <Stack
                flex={1}
                padding={"24px"}
                flexWrap={"wrap"}
                direction={"column"}
                borderRight={"1px solid #E8E8E8"}
            >
                <div style={{display:'flex', justifyContent:'space-between'}}>
					<Tabs
						value={activeTab}
						onChange={(event, value) => {
							setActiveTab(value);
						}}
					>
						{["Violations", "Invoices"]
							.map((title: string, index: number) => {
								return (
									<Tab
										key={index}
										label={title}
										value={index}
										style={{ minWidth: "143px", textTransform: "none" }}
									/>
								);
							})
							.filter((value:any) => value !== undefined)}
					</Tabs>
				</div>
                <Stack
					style={{
						height: window.innerHeight - Datastore.responsiveHeightWithtab - 56 - 120,
						overflowY: "scroll",
                        paddingRight: '24px'
					}}
					marginTop={"32px"}
					direction={"column"}
				>
                    {
                        activeTab === 0 ?
                        <>
                        <Stack direction={'column'}>
                            <span style={{ padding: '16px 0px' }} className="text-787878-16px">{`Active(${activeViolationList.length})`}</span>
                            <ReportedViolationCard isLoading={isLoading} isViolationLoading={isViolationLoading} height={'200px'} ViolationList={activeViolationList} totalViolationList={violationList}/>
                        </Stack>
                        <Stack direction={'column'}>
                            <span style={{ padding: '16px 0px' }} className="text-787878-16px">{`Resolved(${resolveViolationList.length})`}</span>
                            <ReportedViolationCard isLoading={isLoading} isViolationLoading={isViolationLoading} height={'200px'} ViolationList={resolveViolationList} totalViolationList={violationList} />
                        </Stack>
                        </>
                        :
                        <>
                        <Stack direction={'column'}>
                            <span style={{ padding: '16px 0px' }} className="text-787878-16px">{`Active(${activeHoaDueList.length})`}</span>
                            <ReportedHoaDueCard isLoading={isLoading} isHoaDueLoading={isHoaDueLoading} height={'200px'} HoaDueList={activeHoaDueList} />
                        </Stack>
                        <Stack direction={'column'}>
                            <span style={{ padding: '16px 0px' }} className="text-787878-16px">{`Resolved(${resolveHoaDueList.length})`}</span>
                            <ReportedHoaDueCard isLoading={isLoading} isHoaDueLoading={isHoaDueLoading} height={'200px'} HoaDueList={resolveHoaDueList} />
                        </Stack>
                        </>
                    }
                </Stack>
            </Stack>
        </Stack>
    )
}


const ReportedViolationCard = ({ ViolationList, height, isViolationLoading, isLoading, totalViolationList }: any) => {
    const [isViolationModalViewOpen, setIsViolationModalViewOpen] = useState(false);
    const [parentViolation, setParentViolation] = useState({});
    const [violation, setViolation] = useState<any>({});
    const [isViolationStagesModalOpen, setIsViolationStagesModalOpen] = useState(false);

    // open stage modal on violation click
    const onViolationClick = (item: any) => {
        setIsViolationStagesModalOpen(true);
        setViolation(item);
    }

    // open violation modal from stage modal
    const onViolationStageClick = (item: any) => {
        setIsViolationStagesModalOpen(false);
        setIsViolationModalViewOpen(true);
        setParentViolation(violation);
        setViolation(item);
    }

    // close violation modal and open stage modal again
    const onViolationModalViewClose = () => {
        setIsViolationModalViewOpen(false);
        setIsViolationStagesModalOpen(true);
        setViolation(parentViolation);
    }

    // close violation stage modal
    const onCloseViolationStageModal = () => {
        setIsViolationStagesModalOpen(false);
        setViolation({});
    }    
    
    if(isViolationLoading || isLoading){
        return(
            <Stack direction='column' spacing={1}>
                <Skeleton variant="rectangular"  height={92} />
                <Skeleton variant="rectangular"  height={92} />
            </Stack>
        )
    }

    const showHoaId = (item: any) => {
        if (Array.isArray(item?.hoaInfo) && item.hoaInfo.length > 0 && item.hoaInfo[0].hoaId) {
            return item.hoaInfo[0].hoaId
        }
        else {
            return "N/A";
        }
    }

    return (
        <>
            {
                ViolationList && ViolationList.length > 0 ? (
                    <Stack style={{ overflow: "auto" }}>
                        {
                            ViolationList.map((item: any, index: number) => {
                                return (
                                    <Card
                                        variant="outlined"
                                        style={{ background: "#FAFAFA" }}
                                        className="violation-card-container"
                                    >
                                        <Stack direction={"row"} justifyContent={'space-between'}>
                                            <div style={{display:'flex', cursor: 'pointer', width: '100%'}} onClick={()=> onViolationClick(item)}>
                                                <span style={{marginRight: '12px', color: '#9F9F9F'}}>{index+1}</span>
                                                <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                                        <Box>
                                                            <Box style={{fontSize: '12px', fontWeight: 500}} >{item.violation}</Box>
                                                            <Box style={{fontSize: '12px',color: '#9F9F9F', paddingTop: '4px'}}>Added On : {item.createdAt ? new Date(item.createdAt).toLocaleDateString(undefined, { year: 'numeric', month: 'numeric', day: 'numeric' }) : 'N/A'}</Box>
                                                        </Box>
                                                         {item?.violationType && (
                                                            <Box
                                                                sx={{
                                                                    fontSize: '12px',
                                                                    backgroundColor: item.violationType === 'HOA Violation' ? '#e1d1ed' : '#bad9b0',
                                                                    px: '10px',
                                                                    py: '2px',
                                                                    lineHeight: 1.5,
                                                                    borderRadius: '4px',
                                                                    alignSelf: 'flex-start'
                                                                }}
                                                            >
                                                            {item?.violationType}
                                                        </Box>
                                                         )}
                                                    </Box>
                                                    <div style={{display: 'flex', width: '100%', paddingTop: '10px'}}>
                                                        <div style={{display: 'flex', flexDirection: 'column', width: '20%'}}>
                                                            <span style={{fontSize: '12px', fontWeight: 500}} >Hoa ID</span>
                                                            <span style={{fontSize: '12px',color: '#9F9F9F', paddingTop: '4px'}}>{showHoaId(item)}</span>
                                                        </div>
                                                        <div style={{display: 'flex', flexDirection: 'column', width: '50%'}}>
                                                            <span style={{fontSize: '12px', fontWeight: 500}} >Violation ID</span>
                                                            <span style={{fontSize: '12px',color: '#9F9F9F', paddingTop: '4px'}}>{item.objectId ? `${item.propertyId}-${item.objectId}` : 'N/A'}</span>
                                                        </div>
                                                        <div style={{display: 'flex', flexDirection: 'column', width: '30%'}}>
                                                            <span style={{fontSize: '12px', fontWeight: 500}} >Stage</span>
                                                            <span style={{fontSize: '12px',color: '#9F9F9F', paddingTop: '4px'}}>{item.stage || 'N/A'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Stack>
                                    </Card>
                                )
                            })
                        }
                    </Stack>
                )
                : 
                <Card
                    variant="outlined"
                    style={{ background: "#FAFAFA" }}
                    className="violation-card-container"
                >
                    <Stack direction={"row"} justifyContent={'space-between'}>
                        <div style={{display:'flex'}}>
                            <span style={{marginRight: '12px', color: '#9F9F9F'}}>{`No Item Added Yet !`}</span>
                        </div>
                    </Stack>
                </Card>
            }
            <ViolationModalView open={isViolationModalViewOpen} onClose={onViolationModalViewClose} violation={violation}/>
            <HoaPropertyViolationStagesModal
                isViewOnly={true}
                onViolationStageClick={onViolationStageClick}
                isViolationStagesModalOpen={isViolationStagesModalOpen}
                setIsViolationStagesModalOpen={setIsViolationStagesModalOpen}
                violationList={totalViolationList}
                violation={violation}
                onCloseViolationStageModal={onCloseViolationStageModal}
            />
        </>
    ) 
    
}

const ReportedHoaDueCard = ({ HoaDueList, height, isHoaDueLoading, isLoading }: any) => {
    const [open, setOpen] = useState(false);
    const [hoaDue, setHoaDue] = useState<any>({});

    const onClose = () => {
        setOpen(false);
    }

    const hoaDueClick = (item: any) => {
        setOpen(true);
        setHoaDue(item);
    }
    if(isHoaDueLoading || isLoading){
        return(
            <Stack direction='column' spacing={1}>
                <Skeleton variant="rectangular"  height={92} />
                <Skeleton variant="rectangular"  height={92} />
            </Stack>
        )
    }

    return (
        <>
            {
                HoaDueList && HoaDueList.length > 0 ? (
                    <Stack style={{ overflow: "auto" }}>
                        {
                            HoaDueList.map((item: any, index: number) => {

                                return (
                                    <Card
                                    variant="outlined"
                                    style={{ background: "#FAFAFA" }}
                                    className="violation-card-container"
                                    >
                                        <Stack direction={"row"} justifyContent={'space-between'}>
                                            <div style={{display:'flex', cursor: 'pointer'}} onClick={() => hoaDueClick(item)}>
                                                <span style={{marginRight: '12px', color: '#9F9F9F'}}>{index+1}</span>
                                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                                    <span>{`${item.invoiceDetails} - ${getNegativeValueInAccountingForm(item.invoiceAmount)}`}</span>
                                                    <span style={{fontSize: '14px',color: '#9F9F9F', paddingTop: '8px'}}>ID : {`${item.propertyId}-${item.objectId}`}</span>
                                                    <span style={{fontSize: '14px',color: '#9F9F9F', paddingTop: '8px'}}>Added On : {new Date(item.createdAt).toLocaleDateString(undefined, { year: 'numeric', month: 'numeric', day: 'numeric' })}</span>
                                                </div>
                                            </div>
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: HoaDueList[index]?.isHighPriority ? 'flex-end' : 'center',
                                                justifyContent: HoaDueList[index]?.isHighPriority ? 'space-between' : 'center',
                                            }}>
                                                {HoaDueList[index]?.isHighPriority && (
                                                    <Box sx={{
                                                        fontSize: '12px',
                                                        p: '5px',
                                                        background: '#eccbc6',
                                                        color: '#c05142',
                                                        borderRadius: '4px'
                                                    }}>
                                                        High Priority
                                                    </Box>
                                                )}
                                                <IconButton style={{ cursor: 'pointer' }} onClick={() => hoaDueClick(item)}>
                                                    <VisibilityIcon />
                                                </IconButton>
                                            </div>
                                        </Stack>
                                    </Card>
                                )
                            })
                        }
                    </Stack>
                )
                : 
                <Card
                    variant="outlined"
                    style={{ background: "#FAFAFA" }}
                    className="violation-card-container"
                >
                    <Stack direction={"row"} justifyContent={'space-between'}>
                        <div style={{display:'flex'}}>
                            <span style={{marginRight: '12px', color: '#9F9F9F'}}>{`No Item Added Yet !`}</span>
                        </div>
                    </Stack>
                </Card>
            }
            <HoaDueModalView open={open} onClose={onClose} hoaDue={hoaDue}/>
        </>
    ) 
    
}

const ViolationModalView = ({open, onClose, violation}: any) => {
    const onFileDownloadClick = async(url :string) => {
        const newUrl = await GenerateNewDocumentUrl.getNewUrl(url, 'property', 'violationNoticeFiles');
        window.open(urlCheck(newUrl), '_blank');
    }
    const violationDetails: any = {
        'Violation Fees': getNegativeValueInAccountingForm(violation['violationFee']),
        'Violation Date': getDateOnly(violation['violationDate']) || 'N/A',
        'Due Date': getDateOnly(violation['dueDate']) || 'N/A',
        'Stage': violation['stage'] || 'N/A',
        'Notice Date': getDateOnly(violation['noticeDate']) || 'N/A',
        'Violation Category': violation['violationCategory'] || 'N/A',
        'Violation Sub-Category': violation['violationSubcategory'] || 'N/A',
        'Fine Frequency': violation['fineFrequency'] || 'N/A',
        'Hearing Date': getDateOnly(violation['hearingDate']) || 'N/A',
        'Hearing Details': violation['hearingDetails'] || 'N/A',
        'Resolve Instructions': violation['resolveInstructions'] || 'N/A',
        'Hearing Notice': violation['violationNoticeFiles'] || [],
        'Source ID': violation['sourceId'] || 'N/A',
        'Notice Status': violation['noticeStatus'] || 'N/A',
        'Remarks': violation['remarks'] || 'N/A',
        "HOA Information": violation['hoaInfo'] || [],
        "Violation Type": violation['violationType'] || 'N/A'
    }
    return (
        <Modal open={open} onClose={onClose}>
            <Container
                style={{
                    background: "white",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "548px",
                    maxHeight: "645px",
                    overflow: "auto",
                    borderRadius: "5px",
                    padding: "0px",
                    overflowX: 'hidden'
                }}
            >
                <div style={{ background: "#EFF4FC", display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                    <div style={{ display: 'flex', justifyContent: 'space-between'}}>
                        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', padding: '17px 17px 0px 17px' }}>
                            <span style={{ fontSize: '16px', fontWeight: 500, padding: '10px 10px 10px 0px' }}>
                                {violation.violation}
                            </span>
                            <div style={{ height: '30px', padding: '8px 5px 0px 5px', color: '#FFFFFF', borderRadius: '3px', textAlign: 'center', background: violation.noticeStatus === 'active' ? '#6FCF97' : '#ffb600' }}>
                                {violation.noticeStatus === 'active' ? 'Active' : 'Resolved'}
                            </div>
                        </div>
                        <div style={{padding: '27px 17px 0px 17px', cursor: 'pointer'}} onClick={onClose}>
                            <CloseIcon />
                        </div>
                    </div>
                    <span style={{ fontSize: '12px', color: '#787878', padding: "0px 0px 17px 17px", fontWeight: 500 }}>{violation.stage}</span>
                </div>
                <Card
                    variant="outlined"
                    className="violation-card-container"
                >
                    <Stack
                        style={{ borderBottom: "1px solid #E8E8E8", paddingBottom: "24px" }}
                        direction={"row"}
                        flexWrap={"wrap"}
                    >
                        {["Violation Date", "Due Date", "Notice Date", "Stage"].map(
                            (title: string, index: number) => {
                                return (
                                    <Stack
                                        key={index}
                                        style={{ marginTop: "24px" }}
                                        direction="column"
                                        width={'204px'}
                                    >
                                        <span style={{ fontSize: '12px', fontWeight: 500, color: '#787878' }}>{title}</span>
                                        <span style={{ marginTop: "10px", fontSize: '12px', color: '#787878'}}>{violationDetails[title]}</span>
                                    </Stack>
                                );
                            }
                        )}
                    </Stack>
                    <Stack
                        style={{ borderBottom: "1px solid #E8E8E8", paddingBottom: "24px" }}
                        direction={"row"}
                        flexWrap={"wrap"}
                    >
                        {["Violation Type","Violation Fees"].map(
                            (title: string, index: number) => {
                                return (
                                    <Stack
                                        key={index}
                                        style={{ marginTop: "24px" }}
                                        direction="column"
                                        width={'204px'}
                                    >
                                        <span style={{ fontSize: '12px', fontWeight: 500, color: '#787878' }}>{title}</span>
                                        {title === "Violation Type" ? (    
                                        <Box
                                            sx={{
                                              fontSize: '12px',
                                              backgroundColor: violation.violationType === 'HOA Violation' ? '#e1d1ed' : '#bad9b0',
                                              px: '8px',
                                              py: '2px',
                                              marginTop: "10px",
                                              lineHeight: 1.5,
                                              borderRadius: '4px',
                                              alignSelf: 'flex-start'
                                            }}
                                        >
                                            {violationDetails[title]}
                                        </Box>) : <span style={{ marginTop: "10px", fontSize: '12px', color: '#787878'}}>{violationDetails[title]}</span>}
                                    </Stack>
                                );
                            }
                        )}
                    </Stack>
                    <Stack
                        style={{ borderBottom: "1px solid #E8E8E8", paddingBottom: "24px" }}
                        direction={"row"}
                        flexWrap={"wrap"}
                    >
                        {["Violation Category", "Violation Sub-Category", "Fine Frequency"].map(
                            (title: string, index: number) => {
                                return (
                                    <Stack
                                        key={index}
                                        style={{ marginRight: "40px", marginTop: "24px" }}
                                        direction="column"
                                        width={'200px'}
                                    >
                                        <span style={{ fontSize: '12px', fontWeight: 500, color: '#787878' }}>{title}</span>
                                        <span style={{ marginTop: "10px", fontSize: '12px', color: '#787878'}}>{violationDetails[title]}</span>
                                    </Stack>
                                );
                            }
                        )}
                    </Stack>
                     <Stack
                        style={{ paddingTop: "24px", borderBottom: "1px solid #E8E8E8" }}
                        direction={"column"}
                        flexWrap={"wrap"}
                    >

                     {["Hearing Date", "Hearing Details", "Resolve Instructions"].map(
                            (title:string, index:number)=>{
                                return(
                                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%', wordBreak:"break-all" }}>
                                        <div style={{ width: '350px' }}>
                                            <Stack
                                                key={index}
                                                style={{ marginBottom: "24px" }}
                                                direction="column"
                                                >
                                                    <span style={{ fontSize: '12px', fontWeight: 500, color: '#787878' }}>
                                                            {title}
                                                    </span>
                                            </Stack>
                                        </div>
                                        <div style={{ width: '100%' }}>
                                            <Stack
                                                key={index}
                                                style={{ marginBottom: "24px" }}
                                                direction="column"
                                                >
                                                <span style={{ whiteSpace: 'pre-line', fontSize: '12px', color: '#787878' }}>
                                                    {violationDetails[title]}
                                                </span>
                                            </Stack>
                                        </div>
                                    </div>
                                )
                            })
                         }
                        </Stack>
                    <Stack
                        style={{ borderBottom: "1px solid #E8E8E8", paddingBottom: "24px" }}
                        direction={"row"}
                        flexWrap={"wrap"}
                    >
                        {["Hearing Notice"].map(
                            (title: string, index: number) => {
                                return (
                                    <Stack 
                                        key={index}
                                        style={{ marginRight: "40px", marginTop: "24px" }}
                                        direction="column"
                                        width={'200px'}
                                    >
                                    <span style={{ fontSize: '12px', color: '#787878', fontWeight: 500 }}>Notice</span>
                                    <div style={{display:"flex", flexDirection:"column"}}>
                                        {
                                            violationDetails[title] && violationDetails[title]?.length > 0 && violationDetails[title].map((url:any)=>{
                                                return(
                                                <div className="ov-pdf-container" onClick={()=>{onFileDownloadClick(url.url)}} style={{cursor: url?.fileName ? "pointer" : "not-allowed"}}>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <PictureAsPdfIcon style={{ width: '20px', height: '20px' }} />
                                                        <span style={{ marginLeft: '14px', fontSize: '12px', color: '#787878' }}>{url && url.fileName ? url.fileName : "N/A"}</span>
                                                    </div>
                                                    <DownloadIcon style={{ width: '20px', height: '20px', color: '#3576E5' }} />
                                                </div>)
                                            })
                                        }
                                    </div>
                                </Stack>
                                );
                            }
                        )}
                    </Stack>
                    <Stack
                        style={{ borderBottom: "1px solid #E8E8E8", paddingTop: "24px" }}
                        direction={"column"}
                        flexWrap={"wrap"}
                    >
                        <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                            <div style={{ width: '350px' }}>
                                {["Source ID", "Notice Status", "Remarks"].map(
                                    (title: string, index: number) => {
                                        return (
                                            <Stack
                                                key={index}
                                                style={{ marginBottom: "24px" }}
                                                direction="column"
                                            >
                                                <span style={{ fontSize: '12px', fontWeight: 500, color: '#787878' }}>
                                                    {title}
                                                </span>
                                            </Stack>
                                        );
                                    }
                                )}
                            </div>
                            <div style={{ width: '100%' }}>
                                {["Source ID", "Notice Status", "Remarks"].map(
                                    (title: string, index: number) => {
                                        return (
                                            <Stack
                                                key={index}
                                                style={{ marginBottom: "24px" }}
                                                direction="column"
                                            >
                                                <span style={{ whiteSpace: 'pre-line', fontSize: '12px', color: '#787878' }}>
                                                    {violationDetails[title]}
                                                </span>
                                            </Stack>
                                        );
                                    }
                                )}
                            </div>
                        </div>
                    </Stack>
                    <div style={{marginTop: '24px'}}>
                    <span className="text-787878-14px bold">HOA Information</span>
                    <Stack
                        direction={"row"}
                        flexWrap="wrap"
                        padding={"0px 80px 0px 0px"}
                    >
                        { ["HOA Information"].map((title: any, index: number) => {
                            return (
                                <Stack
                                    direction={"column"}
                                    key={index}
                                    marginRight="64px"
                                    paddingBottom="24px"
                                    marginTop={'10px'}
                                >
                                    {violationDetails[title] && violationDetails[title]?.length > 0 &&
                                        violationDetails[title].map((item: any, index: number) => {
                                            return (
                                                <Stack direction={`row`} flexWrap={"wrap"} key={index}>
                                                    <Stack
                                                        style={{ marginRight: "40px", marginTop: "24px" }}
                                                        direction="column"
                                                        width={'200px'}
                                                    >
                                                        <span style={{ fontSize: '12px', color: '#787878', fontWeight: 500 }}>{`HOA ID`}</span>
                                                        <span
                                                            style={{ marginTop: "10px", fontSize: '12px', color: '#787878' }}
                                                        >
                                                            {item?.hoaId}
                                                        </span>
                                                    </Stack>
                                                    <Stack
                                                        style={{ marginRight: "40px", marginTop: "24px" }}
                                                        direction="column"
                                                        width={'200px'}
                                                    >
                                                        <span style={{ fontSize: '12px', color: '#787878', fontWeight: 500 }}>{`HOA Name`}</span>
                                                        <span
                                                            style={{ marginTop: "10px", fontSize: '12px', color: '#787878' }}
                                                        >
                                                            {item?.hoaName}
                                                        </span>
                                                    </Stack>
                                            </Stack>
                                            )
                                        })
                                    }
                                </Stack>
                            );
                        })}
                    </Stack>
                    {(violation?.violationType?.otherEntityInformation || violation?.violationType ==="City Violation") && (
                    <>   
                    <span className="text-787878-14px bold">Other Entity Information</span>
                    <Stack
                        direction={"column"}
                        flexWrap="wrap"
                        padding={"0px 80px 0px 0px"}
                    >
                        <Stack
                            direction={"row"}
                            marginRight="64px"
                            paddingBottom="24px"
                            marginTop={'10px'}
                        >
                            <Stack
                                style={{ marginRight: "40px" }}
                                direction="column"
                                width={'200px'}
                            >
                                <span style={{ fontSize: '12px', color: '#787878', fontWeight: 500 }}>{`Name`}</span>
                                <span
                                    style={{ marginTop: "10px", fontSize: '12px', color: '#787878' }}
                                >
                                    {violation?.otherEntityInformation?.name || 'N/A'}
                                </span>
                            </Stack>
                            <Stack
                                style={{ marginRight: "40px" }}
                                direction="column"
                                width={'200px'}
                            >
                                <span style={{ fontSize: '12px', color: '#787878', fontWeight: 500 }}>{`Email`}</span>
                                <span
                                    style={{ marginTop: "10px", fontSize: '12px', color: '#787878' }}
                                >
                                    {violation?.otherEntityInformation?.email || 'N/A'}
                                </span>
                            </Stack>
                        </Stack>
                        <Stack
                            direction={"row"}
                            marginRight="64px"
                            paddingBottom="24px"
                            marginTop={'10px'}
                        >
                            <Stack
                                style={{ marginRight: "40px" }}
                                direction="column"
                                width={'200px'}
                            >
                                <span style={{ fontSize: '12px', color: '#787878', fontWeight: 500 }}>{`Phone`}</span>
                                <span
                                    style={{ marginTop: "10px", fontSize: '12px', color: '#787878' }}
                                >
                                    {violation?.otherEntityInformation?.phone || 'N/A'}
                                </span>
                            </Stack>
                            <Stack
                                style={{ marginRight: "40px" }}
                                direction="column"
                                width={'200px'}
                            >
                                <span style={{ fontSize: '12px', color: '#787878', fontWeight: 500 }}>{`Address`}</span>
                                <span
                                    style={{ marginTop: "10px", fontSize: '12px', color: '#787878' }}
                                >
                                    {violation?.otherEntityInformation?.address || 'N/A'}
                                </span>
                            </Stack>
                        </Stack>
                    </Stack>
                    </> 
                    )}
                </div>
                </Card>
            </Container>
        </Modal>
    )
}

const HoaDueModalView = ({open, onClose, hoaDue}: any) => {
    const onFileDownloadClick = async(url :string) => {
        const newUrl = await GenerateNewDocumentUrl.getNewUrl(url, 'property', 'hoaDuesNoticeFiles');
        window.open(urlCheck(newUrl), '_blank');
    }
    const hoaDueDetails: any = {
        'Invoice Amount': getNegativeValueInAccountingForm(hoaDue['invoiceAmount']),
        'Notice Date': getDateOnly(hoaDue['noticeDate']) || 'N/A',
        'Due Date': getDateOnly(hoaDue['dueDate']) || 'N/A',
        'Invoice Details': hoaDue['invoiceDetails'] || 'N/A',
        'Hearing Date': getDateOnly(hoaDue['hearingDate']) || 'N/A',
        "High Priority": hoaDue['isHighPriority'] == true ? 'Yes' : 'No',
        'Hearing Details': hoaDue['hearingDetails'] || 'N/A',
        'Hearing Notice': hoaDue['hoaDuesNoticeFiles'] || [],
        'Source ID': hoaDue['sourceId'] || 'N/A',
        'Notice Status': hoaDue['noticeStatus'] || 'N/A',
        'Remarks': hoaDue['remarks'] || 'N/A',
        'Payment Entity Information': hoaDue['paymentEntityInformation'] || 'N/A',
        "HOA Information": hoaDue['hoaInfo'] || []
    }
    return (
        <Modal open={open} onClose={onClose}>
        <Container
            style={{
                background: "white",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "800px",
                maxHeight: "645px",
                overflow: "auto",
                borderRadius: "8px 8px 0px 0px",
                padding: "0px",
                overflowX: 'hidden'
            }}
        >
            <div style={{background: "#EFF4FC", display: 'flex', justifyContent: 'space-between'}}>
                <div className="modal-title-container">
                    <span className="text-3E3E3E-20px bold">{hoaDue.invoiceDetails}</span>
                    <span className="text-5B5B5B-14px  normal">
                        Added On : {new Date(hoaDue.createdAt).toLocaleDateString(undefined, { year: 'numeric', month: 'numeric', day: 'numeric' })}
                    </span>
                </div>
            <div style={{padding: '24px', cursor: 'pointer'}} onClick={onClose}>
                <CloseIcon />
            </div>
            </div>
            <Card
                variant="outlined"
                className="violation-card-container"
            >
                <Stack
                    style={{ borderBottom: "1px solid #E8E8E8", paddingBottom: "24px" }}
                    direction={"row"}
                    flexWrap={"wrap"}
                >
                    {["Invoice Amount", "Notice Date", "Due Date"].map(
                        (title: string, index: number) => {
                            return (
                                <Stack
                                    key={index}
                                    style={{ marginRight: "40px", marginTop: "24px" }}
                                    direction="column"
                                    width={'200px'}
                                >
                                    <span className="text-787878-14px bold">{title}</span>
                                    <span
                                        style={{ marginTop: "10px" }}
                                        className="text-303030-16px normal"
                                    >
                                        {hoaDueDetails[title]}
                                    </span>
                                </Stack>
                            );
                        }
                    )}
                </Stack>
                <Stack
                    style={{ borderBottom: "1px solid #E8E8E8", paddingBottom: "24px" }}
                    direction={"column"}
                    flexWrap={"wrap"}
                >
                    {["Hearing Date", "High Priority","Hearing Details"].map(
                        (title: string, index: number) => {
                            return (
                                <Stack
                                    key={index}
                                    style={{ marginRight: "40px", marginTop: "24px" }}
                                    direction="column"
                                >
                                    <span className="text-787878-14px bold">{title}</span>
                                    <span
                                        style={{ marginTop: "10px", whiteSpace: 'pre-line' }}
                                        className="text-303030-16px normal"
                                    >
                                        {hoaDueDetails[title]}
                                    </span>
                                </Stack>
                            );
                        }
                    )}
                </Stack>
                <Stack
                    style={{ borderBottom: "1px solid #E8E8E8", paddingBottom: "24px" }}
                    direction={"row"}
                    flexWrap={"wrap"}
                >
                    {["Hearing Notice"].map(
                        (title: string, index: number) => {
                            return (
                                <Stack 
                                    key={index}
                                    style={{ marginRight: "40px", marginTop: "24px" }}
                                    direction="column"
                                    width={'200px'}
                                >
                                <span className="text-787878-14px bold">Notice</span>
                                <div style={{display:"flex", flexDirection:"column"}}>
                                    {
                                        hoaDueDetails[title] && hoaDueDetails[title]?.length > 0 && hoaDueDetails[title].map((url:any)=>{
                                            return(
                                            <div className="ov-pdf-container" onClick={()=>{onFileDownloadClick(url.url)}} style={{cursor: url?.fileName ? "pointer" : "not-allowed"}}>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <PictureAsPdfIcon style={{ width: '20px', height: '20px' }} />
                                                    <span style={{ marginLeft: '14px' }} className="text-3E3E3E-14px">{url && url.fileName ? url.fileName : "N/A"}</span>
                                                </div>
                                                <DownloadIcon style={{ width: '20px', height: '20px', color: '#3576E5' }} />
                                            </div>)
                                        })
                                    }
                                </div>
                            </Stack>
                            );
                        }
                    )}
                </Stack>
                <Stack
                    style={{ borderBottom: "1px solid #E8E8E8", paddingBottom: "24px" }}
                    direction={"column"}
                    flexWrap={"wrap"}
                >
                    {["Source ID", "Notice Status", "Remarks"].map(
                        (title: string, index: number) => {
                            return (
                                <Stack
                                    key={index}
                                    style={{ marginRight: "40px", marginTop: "24px" }}
                                    direction="column"
                                >
                                    <span className="text-787878-14px bold">{title}</span>
                                    <span
                                        style={{ marginTop: "10px", whiteSpace: 'pre-line' }}
                                        className="text-303030-16px normal"
                                    >
                                        {hoaDueDetails[title]}
                                    </span>
                                </Stack>
                            );
                        }
                    )}
                </Stack>

                <div style={{paddingTop: '24px', borderBottom: "1px solid #E8E8E8" }}>
                    <span className="text-787878-14px bold">Payment Entity Information</span>
                    <Stack
                        direction={"column"}
                        flexWrap="wrap"
                        padding={"24px 0px 0px 0px"}
                    >
                        <Stack
                            direction={"row"}
                            marginRight="64px"
                            paddingBottom="24px"
                            marginTop={'10px'}
                        >
                            <Stack
                                style={{ marginRight: "40px" }}
                                direction="column"
                                width={'200px'}
                            >
                                <span className="text-787878-14px bold">{`Name`}</span>
                                <span
                                    className="text-303030-16px normal"
                                    style={{ marginTop: "10px" }}
                                >
                                    {hoaDue?.paymentEntityInformation?.name || 'N/A'}
                                </span>
                            </Stack>
                            <Stack
                                style={{ marginRight: "40px" }}
                                direction="column"
                                width={'200px'}
                            >
                                <span className="text-787878-14px bold">{`Email`}</span>
                                <span
                                    className="text-303030-16px normal"
                                    style={{ marginTop: "10px" }}
                                >
                                    {hoaDue?.paymentEntityInformation?.email || 'N/A'}
                                </span>
                            </Stack>
                            <Stack
                                style={{ marginRight: "40px" }}
                                direction="column"
                                width={'200px'}
                            >
                                <span className="text-787878-14px bold">{`Mailing Address`}</span>
                                <span
                                    className="text-303030-16px normal"
                                    style={{ marginTop: "10px" }}
                                >
                                    {hoaDue?.paymentEntityInformation?.mailingAddress || 'N/A'}
                                </span>
                            </Stack>
                        </Stack>
                        <Stack
                            direction={"row"}
                            marginRight="64px"
                            paddingBottom="24px"
                            marginTop={'10px'}
                        >
                            <Stack
                                style={{ marginRight: "40px" }}
                                direction="column"
                                width={'200px'}
                            >
                                <span className="text-787878-14px bold">{`Phone`}</span>
                                <span
                                    className="text-303030-16px normal"
                                    style={{ marginTop: "10px" }}
                                >
                                    {hoaDue?.paymentEntityInformation?.phone || 'N/A'}
                                </span>
                            </Stack>
                            <Stack
                                style={{ marginRight: "40px" }}
                                direction="column"
                                width={'200px'}
                            >
                                <span className="text-787878-14px bold">{`Address`}</span>
                                <span
                                    className="text-303030-16px normal"
                                    style={{ marginTop: "10px" }}
                                >
                                    {hoaDue?.paymentEntityInformation?.address || 'N/A'}
                                </span>
                            </Stack>
                            <Stack
                                style={{ marginRight: "40px" }}
                                direction="column"
                                width={'200px'}
                            >
                                <span className="text-787878-14px bold">{`Website`}</span>
                                <span
                                    className="text-303030-16px normal"
                                    style={{ marginTop: "10px" }}
                                >
                                    {hoaDue?.paymentEntityInformation?.website || 'N/A'}
                                </span>
                            </Stack>
                        </Stack>
                    </Stack>
                </div>

                <Stack
                    direction={"row"}
                    flexWrap="wrap"
                    padding={"0px 80px 0px 0px"}
                >
                    { ["HOA Information"].map((title: any, index: number) => {
                        return (
                            <Stack
                                direction={"column"}
                                key={index}
                                marginRight="64px"
                                paddingBottom="24px"
                                marginTop={'10px'}
                            >
                                {hoaDueDetails[title] && hoaDueDetails[title]?.length > 0 &&
                                    hoaDueDetails[title].map((item: any, index: number) => {
                                        return (
                                            <Stack direction={`row`} flexWrap={"wrap"} key={index}>
                                                <Stack
                                                    style={{ marginRight: "40px", marginTop: "24px" }}
                                                    direction="column"
                                                    width={'200px'}
                                                >
                                                    <span className="text-787878-14px bold">{`HOA ID`}</span>
                                                    <span
                                                        style={{ marginTop: "10px" }}
                                                        className="text-303030-16px normal"
                                                    >
                                                        {item?.hoaId}
                                                    </span>
                                                </Stack>
                                                <Stack
                                                    style={{ marginRight: "40px", marginTop: "24px" }}
                                                    direction="column"
                                                    width={'200px'}
                                                >
                                                    <span className="text-787878-14px bold">{`HOA Name`}</span>
                                                    <span
                                                        style={{ marginTop: "10px" }}
                                                        className="text-303030-16px normal"
                                                    >
                                                        {item?.hoaName}
                                                    </span>
                                                </Stack>
                                        </Stack>
                                        )
                                    })
                                }
                            </Stack>
                        );
                    })}
                </Stack>
            </Card>
        </Container>
        </Modal>
    )
}


export default PropertyViolation;